<template>
  <div class="h-screen flex flex-col items-center justify-center bg-purple-900">
    <div class="text-4xl font-medium text-red-500 mb-4" data-content="403">
      403 - {{ $lang.app.ACCESS_DENIED }}
    </div>

    <div class="font-medium mb-6 text-white text-xl">
      {{ $lang.app.ACCESS_DENIED_DESCRIPTION }}
    </div>

    <div>
      <button class="border-2 border-blue-500 font-medium hover:border-white hover:text-white px-3 py-1 rounded text-blue-500 text-lg"
              @click="$router.push({name: 'Home'})">{{ $lang.app.RETURN_TO_MAIN_PAGE }}</button>
    </div>
  </div>
</template>
<script>
export default {
  name: '403'
}
</script>